import { render } from "./Locked-Page.vue?vue&type=template&id=71ecb210&scoped=true&lang=html"
import script from "./Locked-Page.vue?vue&type=script&lang=js"
export * from "./Locked-Page.vue?vue&type=script&lang=js"

import "./Locked-Page.vue?vue&type=style&index=0&id=71ecb210&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ecb210"]])

export default __exports__